module.exports = __webpack_public_path__ + "static/images/containers/MigrationScreen/images/slide_1.f23f497e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MigrationScreen/images/slide_1.png
// module id = 3205
// module chunks = 11